/* eslint-disable camelcase */
import { createSelector } from 'reselect';
import formatCurrency from 'lib/format-currency';
import translations from 'translations';
import configSelector from './config';

const selectPayloadByKey = createSelector(
  (state) => state.aggr.payload,
  (_, key) => key,
  (payload, key) => payload[key],
);

const selectTopLine = createSelector(selectPayloadByKey, configSelector, (payload, config) => {
  const { languageCode } = config;
  if (!payload || !payload.data) return [];

  const {
    currency,
    query,
    data: {
      aggregations: {
        results: { buckets },
      },
    },
  } = payload;

  const isUsage = query.includes('usage_data');
  let currentTotal = 0;
  let durationTotal = 0;

  buckets.forEach((data) => {
    const {
      current_period: {
        total_revenues: { value },
        total_duration: { value: valueDuration },
      },
    } = data;

    currentTotal += value;
    durationTotal += valueDuration;
  });

  return buckets
    .map((data) => {
      const { key: title, current_period, previous_period } = data;

      const totalCurrentRevenues = formatCurrency(currency, current_period.total_revenues.value);
      const totalPreviousRevenues = formatCurrency(currency, previous_period.total_revenues.value);
      const totalCurrentDuration = `${parseFloat(current_period.total_duration.value / 60).toFixed(
        1,
      )} ${translations[languageCode].hours}`;
      const totalPreviousDuration = `${parseFloat(
        previous_period.total_duration.value / 60,
      ).toFixed(1)} ${translations[languageCode].hours}`;

      let percentEarning = 0;
      if (previous_period.total_revenues.value !== 0) {
        percentEarning = Math.round(
          ((current_period.total_revenues.value - previous_period.total_revenues.value) /
            previous_period.total_revenues.value) *
            100,
        );
      }

      let percentTrend = 0;
      if (previous_period.total_duration.value !== 0) {
        percentTrend = Math.round(
          ((current_period.total_duration.value - previous_period.total_duration.value) /
            previous_period.total_duration.value) *
            100,
        );
      }

      let percent = 0;
      if (currentTotal > 0) percent = Math.round((current_period.total_revenues.value * 100) / currentTotal);

      let percentDuration = 0;
      if (durationTotal > 0) percentDuration = Math.round((current_period.total_duration.value * 100) / durationTotal);

      return {
        title,
        unformattedRevenues: current_period.total_revenues.value,
        unformattedDuration: current_period.total_duration.value,
        totalCurrentRevenues,
        totalPreviousRevenues,
        totalCurrentDoc: current_period.doc_count,
        totalCurrentQuantity: current_period.total_quantity.value,
        totalPreviousQuantity: previous_period.total_quantity.value,
        totalCurrentDuration,
        totalPreviousDuration,
        percentEarning,
        percent,
        percentTrend,
        percentDuration,
      };
    })
    .sort((a, b) => !isUsage ? a.unformattedRevenues - b.unformattedRevenues : a.unformattedDuration - b.unformattedDuration)
    .reverse();
});

export default selectTopLine;
